<template>
  <div class="add-identity">

    <div class="identity-info">

        <h2 class="tip-tit">温馨提示：如已更换手机，需业主前往服务中心更新</h2>
        <mt-cell title="业主预留手机号"></mt-cell>
        <mt-field class="phone" :label="phoneIdx" placeholder="请补齐手机号" type="tel" v-model="phone"></mt-field>
        <!-- <mt-field placeholder="请输入验证码" v-model="captcha" class="verify" >
            <button href="#" @click="getCaptcha()">{{captchaTit}}</button>
        </mt-field> -->

        <!-- <h2 class="tip-tit">
            接收不到验证码，可以试试<a href="#" @click="getCaptcha()">语音验证码</a>
        </h2> -->
        <mt-cell title="与房屋之间的关系"></mt-cell>
        <mt-radio v-model="radioVal" :options="radioOpts"></mt-radio>

    </div>

    <div class="identity-btns">
        <!-- <button class="server" @click="showInfo()"><i></i>客服电话</button> -->
        <a :href="auth_tel" class="server"><i></i>客服电话</a>
        <button class="sub-info" @click="subAssign()">提交认证</button>
    </div>

  </div>
</template>
<script>
import {MessageBox} from 'mint-ui';
//const SMSClient = require('@alicloud/sms-sdk');
const accessKeyId = 'LTAI9XmrimwBkUue';
const secretAccessKey = 'qPqDWgetBhO4Ciw1boZMjZq840NVhR';
export default {
  data () {
    return {
        room_id:0,
        phoneIdx: '0000000',
        phone: '', // 电话号
        captcha: '', // 验证码
        radioVal: '1', // 选择的房主关系值
        radioOpts: [
            {
                label: '房产证在我名下',
                value: '1'
            },
            {
                label: '我是业主家属',
                value: '2'
            },
            {
                label: '我是租客',
                value: '3'
            }
        ],
        captchaTit: '获取验证码',
        userId:'',
        randNum:'',
        link_relate_id:'',
        auth_tel:'',
        owner_tel:''
    }
  },
  created(){
    this.room_id = this.$route.query.room_id;
    this.userId = this.$route.query.userId;
    this.link_relate_id = this.$route.query.link_relate_id;
    this.getOwnerInfo();
  },
  methods: {
    showInfo(){

    },
    //发送验证码
    send(){

    },
    checkMobile(sMobile){
        
        if(!(/^1[3|4|5|8][0-9]\d{4,8}$/.test(sMobile))){ 
            return false; 
        }else{
            return true;
        }    
    },
    // 获取业主信息
    getOwnerInfo () {

        let json = JSON.stringify({"user_id":this.userId,"user_uid":this.userId,"room_id":""+this.room_id+"","is_share":true});
        this.$indicator.open();
        this.axios.get('/jmobile/OwnerAuth/getOwnerTel/json/'+json).then((res)=>{
            this.$indicator.close();
            console.log(res.data.data.owner_tel);
            if(res.data.status == '1'){
                if(res.data.data.owner_tel == '0000000000'){
                    MessageBox({
                        title:'提示',
                        message:'业主预留手机号格式不正确,请联系物业,电话:'+res.data.data.auth_tel,
                        confirmButtonText:'打电话',
                        showCancelButton:true,
                        cancelButtonText:'关闭'
                    }).then(action=>{

                         if(action == 'confirm'){
                            MessageBox({
                                 title:'提示',
                                 message:'您确认要拨打电话：'+res.data.data.auth_tel+'吗？',
                                 showCancelButton:true
                             }).then(action=>{
                                 if(action == 'confirm'){
                                    console.log('vue需要调起打电话');
                                 }else{
                                    //history.go(-1);
                                 }
                             });
                         }else{
                             //history.go(-1);
                         }
                   });
                }else{
                   this.phoneIdx = res.data.data.owner_tel.substring(0,7);
                   this.owner_tel = res.data.data.owner_tel;
                   this.auth_tel = 'tel:' + res.data.data.auth_tel;
                   let is_check = this.checkMobile(res.data.data.owner_tel);
                }
                
            }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'1000'
                });
            }
           
        }).catch((response)=>{
            this.$indicator.close();
            this.$toast({
                message:'网络错误',
                position:'bottom',
                duration:'1000'
            })
        });
    },
    // 获取验证码
    getCaptcha () {

        let qs = require('querystring');

        if(this.phone.length != 4){
            MessageBox.alert('请补齐手机号','提示');
            return false;
        }

        let phone_num = this.phoneIdx + this.phone;

        let data={};
            data.tel = phone_num;
        this.axios.post('/jmobile/MyVillageRoom/limit_notice',data).then((res)=>{
            let time = 60;
            let timer = null;
            this.captchaTit = `${time}秒`;
            timer = setInterval( () => {
                if(time == 1){
                    this.captchaTit = `获取验证码`;
                    clearInterval(timer);
                }else{
                    time--;
                    this.captchaTit = `${time}秒`;
                }
            }, 1000);

            

            //phone_num = '15643340629';
            //return false;
            this.getRandNum();
            //走后台接口发送短信
        
             let messageData = JSON.stringify({'mobile':phone_num,'rand_code':this.randNum});
            this.axios.post('/jmobile/MyVillageRoom/send_message',messageData).then((res)=>{
                if(res.data.status == '1'){

                }else{

                }
            }).catch((res)=>{
                this.$toast({
                    message:'网络错误',
                    position:'bottom',
                    duration:'3000'
                })
            })


            // let smsClient = new SMSClient({accessKeyId, secretAccessKey});
            // smsClient.sendSMS({
            //     PhoneNumbers:phone_num,
            //     SignName:'楼里楼外',
            //     TemplateCode:'SMS_134316484',
            //     //TemplateParam:'{"code":"12345","customer":"'+this.randNum+'"}'
            //     TemplateParam:'{"code":"'+this.randNum+'"}'
            // }).then(function (res) {
            //         let {Code}=res;
            //         if (Code === 'OK') {
            //             //处理返回参数
            //             console.log(res);
            //         }else{
            //             console.log(res);
            //         }
            //     }, function (err) {
            //         console.log(err);
            // });
        }).catch((res)=>{
            this.$toast({
                message:'网络错误',
                position:'bottom',
                duration:'3000'
            })
        });

        return false;

    },
    subAssign(){

        // if(this.captcha == ''){
        //      MessageBox.alert('请先获取验证码','提示');
        //      return false;
        // }

        // if(this.randNum != this.captcha){
        //      MessageBox.alert('四位验证码输入有误,请确认！','提示');
        //      return false;
        // }

        if(this.owner_tel != this.phoneIdx + this.phone){
            MessageBox.alert('手机号输入错误','提示');
            return false;
        }

        //提交认证接口
        let data;
            data = {user_id:this.userId,link_relate_id:this.link_relate_id,user_relation:this.radioVal};
            data = JSON.stringify(data);

        this.axios.get('/jmobile/MyVillageRoom/authRoom/json/'+data).then((res)=>{
                if(res.data.status == '1'){
                    this.$toast({
                        message:'绑定成功',
                        position:'bottom',
                        duration:'2000'
                    });
                    history.go(-1)
                }else{  
                    this.$toast({
                        message:res.data.info,
                        position:'bottom',
                        duration:'2000'
                    });
                }
        }).catch((res)=>{
            this.$toast({
                message:'网络错误',
                position:'bottom',
                duration:'2000'
            })
        });
    },
    getRandNum(){
        let num = "";
        for(let i=0;i<4;i++){
            num += Math.floor(Math.random()*10)
        }
        this.randNum = num;
    }
  }
}
</script>
<style lang="less">
.add-identity{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #f2f2f2;
    .identity-info{
        position: absolute;
        top: 0;
        width: 100%;
        bottom: 50px;
        .mint-cell{
            padding: 0 15px;
            min-height: 54px;
            .mint-cell-wrapper{
                padding: 0;
                background-image: none;
                font-size: 15px;
                border-bottom: 1px solid #ececec;
            }
            &.phone{
                .mint-cell-title{
                    width: 85px;
                }
            }
            &.verify{
                .mint-cell-wrapper{
                    border-bottom: none;
                }
                button{
                    display: inline-block;
                    margin: 0 5px 0 10px;
                    width: 110px;
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                    background-color: #ffaf14;
                    color: #fff;
                    border-radius: 5px;
                    font-size: 15px;
                }
            }
        }
        .mint-radiolist{
            .mint-radiolist-title{
                margin: 0;
            }
            .mint-cell-wrapper{
                border-bottom: none;
            }
            .mint-radio-input:checked + .mint-radio-core{
                background-color: #fff;
                border-color: #ffaf14;
            }
            .mint-radio-core::after{
                background-color: #ffaf14;
            }
        }
        .tip-tit{
            padding: 10px 15px;
            color: #717171;
            font-size: 13px;
            font-weight: normal;
            a{
                color: #31a2f2;
            }
        }
    }
    .identity-btns{
        display: flex;
        position: absolute;
        bottom: 0;
        height: 50px;
        width: 100%;
        .server{
            box-sizing: border-box;
            padding-top: 5px;
            width: 90px;
            text-align: center;
            height: 50px;
            color: #ffaf14;
            font-size: 12px;
            background-color: #fff;
            i{
                display: block;
                margin: 0 auto 5px;
                width: 20px;
                height: 20px;
                background-image: url(../assets/phone@2x.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }
        }
        .sub-info{
            flex: 1;
            height: 50px;
            line-height: 50px;
            color: #fff;
            text-align: center;
            font-size: 17px;
            background-color: #ffaf14;
        }
    }
}

</style>




// WEBPACK FOOTER //
// src/components/MyIdentity.vue